export const REMINDER_REGISTRATIONS = ["pending", "registered", "rejected", "releasing"] as const;

export type ReminderRegistration = (typeof REMINDER_REGISTRATIONS)[number];

type ReminderReleaseReason = "signed-out" | "user-changed" | "preference-off";

interface ReminderOptIn {
  optedInUserId: string | null | undefined;
  currentUserId: string | null | undefined;
  channelEnabled: boolean;
}

// No opt-in means nothing to release; no current user is a sign-out; a different user means the opt-in is not theirs; a disabled channel means the user turned it off.
export function getReminderReleaseReason({ optedInUserId, currentUserId, channelEnabled }: ReminderOptIn): ReminderReleaseReason | null {
  if (!optedInUserId) return null;
  if (!currentUserId) return "signed-out";
  if (optedInUserId !== currentUserId) return "user-changed";
  return channelEnabled ? null : "preference-off";
}

// A device registers only for the same user who opted in, with the channel still on.
export function canRegisterReminderDevice(optIn: ReminderOptIn): boolean {
  return Boolean(optIn.optedInUserId) && getReminderReleaseReason(optIn) === null;
}

// Turning the last mobile preference off needs a device release; any other change just needs a fresh registration.
export function registrationAfterPreferenceChange(wasEnabled: boolean | undefined, isEnabled: boolean): ReminderRegistration {
  return wasEnabled === true && !isEnabled ? "releasing" : "pending";
}
